import React, { useMemo, useState } from "react";
import PopupFrame from "../../modules/popup/PopupFrame";
import RoboImgSettingPopup from "./RoboImgSettingPopup";
import RoboInpatingSettingPopup from "./RoboInpatingSettingPopup";
import ai_badge from "../../../resources/img/ai_badge.svg";

const RoboImageStudioTabs = ({
  className = "",
  eventSeq = "-1",
  imgPosition = "-1",
  bannerCd = "-1",
  bannerDirection = "-1",
  onClose = () => {},
  sendRoboImg = () => {},
  defaultTab = "GENERATE",
  remountOnTabSwitch = false,
  isSquareOnly = false,
  defaultImageLink = "",
  ratio= "",
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const commonChildProps = useMemo(
    () => ({
      className,
      eventSeq,
      imgPosition,
      bannerCd,
      bannerDirection,
      onClose,
      sendRoboImg,
      isSquareOnly,
      defaultImageLink,
      ratio,
    }),
    [className, eventSeq, imgPosition, bannerCd, bannerDirection, onClose, sendRoboImg, isSquareOnly, defaultImageLink, ratio]
  );

  const handleApplyAndClose = (imgUrl, stabilityCallSeq) => {
    sendRoboImg(imgUrl, stabilityCallSeq);
    onClose();
  };

  return (
    <div style={{ 
      position: "fixed",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      zIndex: 99999,
    }}>
      <PopupFrame
        maxWidth="100%"
        minWidth="480px"
        width="auto"
        title="AI 이미지 스튜디오"
        titleIcon={ai_badge}
        content="AI가 상품 이미지를 새로 만들어드려요.<br/>원하시는 방식을 선택해 보세요!"
        onClose={onClose}
      >
        <div id="RoboImageStudioTabs" className={["robo_image_studio_tabs", className].join(" ")}>
          {/* 탭 헤더 */}
          <div className="tab_header card">
            <button
              type="button"
              className={`tab_button ${activeTab === "GENERATE" ? "active" : ""}`}
              onClick={() => setActiveTab("GENERATE")}
            >
              AI로 이미지 만들기
            </button>
            <button
              type="button"
              className={`tab_button ${activeTab === "INPAINT" ? "active" : ""}`}
              onClick={() => setActiveTab("INPAINT")}
            >
              AI로 배경 바꾸기
            </button>

            {/* 민트색 언더바 인디케이터 */}
            <div
              className="tab_indicator"
              style={{
                transform: `translateX(${activeTab === "INPAINT" ? "100%" : "0%"})`,
              }}
            />
          </div>
          {/* 탭 콘텐츠 */}
          {remountOnTabSwitch ? (
            <div className="tab_body">
              {activeTab === "GENERATE" ? (
                <RoboImgSettingPopup
                  key="tab-generate"
                  {...commonChildProps}
                  sendRoboImg={handleApplyAndClose}
                />
              ) : (
                <RoboInpatingSettingPopup
                  key="tab-inpaint"
                  {...commonChildProps}
                  sendRoboImg={(url) => handleApplyAndClose(url, undefined)}
                />
              )}
            </div>
          ) : (
            <div className="tab_body">
              <div style={{ display: activeTab === "GENERATE" ? "block" : "none" }}>
                <RoboImgSettingPopup {...commonChildProps} sendRoboImg={handleApplyAndClose} />
              </div>
              <div style={{ display: activeTab === "INPAINT" ? "block" : "none" }}>
                <RoboInpatingSettingPopup
                  {...commonChildProps}
                  sendRoboImg={(url) => handleApplyAndClose(url, undefined)}
                />
              </div>
            </div>
          )}
        </div>
      </PopupFrame>
    </div>
  );
};

export default RoboImageStudioTabs;